import { createContext } from 'react';

const MtlsContext = createContext();

export default MtlsContext;
